import Vue from 'vue';
import inAppAlertsApi from 'api-client/inAppAlerts';

const inAppAlertsModule = {
  state: {
    inAppAlerts: {}
  },
  getters: {
    inAppAlerts: state => (appId) => {
      return state.inAppAlerts[appId] ? state.inAppAlerts[appId] : []
    }
  },
  mutations: {
    setInAppAlerts(state, {appId, data}) {
      if (!state.inAppAlerts[appId]) {
        Vue.set(state.inAppAlerts, appId, {});
      }
      Vue.set(state.inAppAlerts, appId, data);
    }
  },
  actions: {
    fetchInAppAlerts({commit}, appId) {
      commit('setIsLoading', true);

      return inAppAlertsApi.getAlerts(appId)
        .then((alertsResponse) => {
          commit('setInAppAlerts', {appId, data: alertsResponse});
          commit('setIsLoading', false);
        })
        .catch(() => {
          commit('setIsLoading', false);
        });
    },
    updateInAppAlert({commit}, {appCode, title, body, startDateTime, finishDateTime}) {
      commit ('setIsLoading', true);
      return inAppAlertsApi.updateAlert(appCode, title, body, startDateTime, finishDateTime)
        .then((response) => {
          commit('setInAppAlerts', {appId: appCode, data: [response]});
          commit('setIsLoading', false);
        })
        .catch(() => {
          commit('setIsLoading', false);
        });
    }
  }
};

export default inAppAlertsModule;